import React from 'react';
import { sectionGap } from './adminFormStyles';

const AdminFormSection = ({ title, description, children, className = '' }) => (
  <section className={`${sectionGap} ${className}`}>
    {(title || description) && (
      <div className="border-b border-gray-100 pb-2 mb-1">
        {title && <h2 className="text-sm font-semibold text-gray-900">{title}</h2>}
        {description && <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">{description}</p>}
      </div>
    )}
    {children}
  </section>
);

export default AdminFormSection;
